import { FETCHED_PRODUCT_CATEGORIES } from '../event-types';

export default (state = [], action) => {
    switch (action.type) {
    case FETCHED_PRODUCT_CATEGORIES:
        return action.payload;
    default:
        return state;
    }
};
